export enum SidebarPosition {
  Left = 'left',
  Right = 'right'
}
